import KyePreview from './component/index.vue'

export default KyePreview



// WEBPACK FOOTER //
// ./src/public/components/kye-preview/index.js